import styled from "styled-components";
import {ClockLastLoginDefaultBox} from "./clock-last-login.default.box";

export const ClockLastLoginSiBox = styled(ClockLastLoginDefaultBox)`
  ::before {
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      background-position: -65px -416px;
    }
  }
  
`